export const environment = {
  backendUrl: 'https://api.num-dev.nederman.com/dev',
  loginPath: '/login',
  graphqlPath: '/graphiql',
  production: false,
  nordfab: () => window.location?.hostname == 'nordfab.com' || window.location?.hostname?.endsWith('.nordfab.com'),
  name: 'development'
};
